import React from 'react';
import { number, string } from 'prop-types';
import { N400 } from '@/colors/colorsV1';

const InfoFilled = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Style=Filled">
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 9C12.8284 9 13.5 8.32843 13.5 7.5C13.5 6.67157 12.8284 6 12 6C11.1716 6 10.5 6.67157 10.5 7.5C10.5 8.32843 11.1716 9 12 9ZM13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V12Z"
        fill={color}
      />
    </g>
  </svg>
);

InfoFilled.propTypes = {
  color: string,
  size: number,
};

InfoFilled.defaultProps = {
  color: N400,
  size: 20,
};

export default InfoFilled;
